/* eslint-disable regexp/no-unused-capturing-group */

import {not} from '../conditionalUtils';

export const isValidDateTimeString = (input: string) => {
  const isoRegex =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;

  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

  if (not(isoRegex.test(input) || dateRegex.test(input))) {
    return false;
  }

  const timestamp = new Date(input).getTime();

  return !isNaN(timestamp);
};
